export const auth = {
  failed: "Authentication failed"
};
